import useLegalDocsBlockGuard from 'hooks/useLegalDocsBlockGuard'
import useLegalDocsNag from 'hooks/useLegalDocsNag'
import React from 'react'
import LegalDocsBlockModal from './LegalDocsBlockModal'
import LegalDocsNagModal from './LegalDocsNagModal'

const LegalDocsNagGuard: React.FC = () => {
  const nag = useLegalDocsNag()
  const block = useLegalDocsBlockGuard()

  return (
    <>
      <LegalDocsNagModal
        isOpen={nag.showModal}
        onDismiss={nag.dismiss}
        onSetupLegalDocs={nag.handleSetupLegalDocs}
      />
      <LegalDocsBlockModal
        isOpen={block.showModal}
        onContinue={block.handleContinue}
      />
    </>
  )
}

export default LegalDocsNagGuard
